export const announcement = [
    {
      date: "12 พฤศจิกายน 2567",
      title:
        "ประกาศกรมปศุสัตว์ เรื่อง กำหนดท้องที่และชนิดสัตว์ที่ต้องทำเครื่องหมายประจำตัวสัตว์ และการทำเครื่องหมายประจำตัวสัตว์ ประเภท ม้า ลา ล่อ และม้าลาย พ.ศ. 2563",
    },
    {
      date: "6 ตุลาคม 2567",
      title:
        "ประกาศกรมปศุสัตว์ เรื่อง กำหนดด่านกักกันสัตว์ ตามพระราชบัญญัติโรคระบาดสัตว์ พ.ศ. 2558",
    },
    {
      date: "18 กันยายน 2567",
      title:
        "ประกาศกรมปศุสัตว์ เรื่อง กำหนดแบบบัตรประจำตัวสัตวแพทย์และสารวัตร ตามพระราชบัญญัติโรคระบาดสัตว์ พ.ศ. 2558",
    },
    {
      date: "6 กันยายน 2567",
      title:
        "ประกาศกรมปศุสัตว์ เรื่อง กำหนดหลักเกณฑ์ วิธีการ และเงื่อนไข การนำสัตว์และซากสัตว์ผ่านด่านกักสัตว์ พ.ศ. 2558",
    },
    {
      date: "7 มิถุนายน 2567",
      title:
        "ประกาศกรมปศุสัตว์ เรื่อง การขออนุญาต การออกใบอนุญาต วิธีการนำเข้า ส่งออก หรือนำผ่านราชอาณาจักร ซึ่งสัตว์หรือซากสัตว์ พ.ศ. 2558",
    },
    {
      date: "24 กุมภาพันธ์ 2567",
      title:
        "ประกาศกรมปศุสัตว์ เรื่อง กำหนดหลักเกณฑ์ และวิธีการมีสิทธิเรียกร้องค่าใช้จ่ายที่จำเป็นเท่าที่จ่ายจริงจากเจ้าของสัตว์ เมื่อปรากฏเจ้าของสัตว์ในภายหลัง พ.ศ. 2558",
    },
  ];